






















import Vue from "vue";
import Component from "vue-class-component";
import Rule from "@/types/Rule";
import rulesJson from "@/content/rules.json";

@Component({
  metaInfo: {
    title: "Unit Rules – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "By playing with the Newfound Pioneer Corps Arma 3 unit you confirm to adhere to our event rules, which you can find here." },
      { vmid: "og:title", property: "og:title", content: "Unit Rules – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "By playing with the Newfound Pioneer Corps Arma 3 unit you confirm to adhere to our event rules, which you can find here." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/rules" },
    ],
  },
})
export default class Rules extends Vue {
  private rules: Rule[] = rulesJson;
}
